import type { ChangeEvent, FC } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormControlLabel, FormGroup, Switch, Typography } from '@mui/material';

export interface TranslationToggleProps {
  isDefaultLanguage: boolean;
  onToggle: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
}

const TranslationToggle: FC<TranslationToggleProps> = ({
  isDefaultLanguage,
  onToggle,
}) => {
  const { t } = useTranslation('common');

  return (
    <FormGroup>
      <FormControlLabel
        control={<Switch checked={isDefaultLanguage} onChange={onToggle} />}
        label={
          <Typography variant="body3">
            {/* Might seem wrong, but the button label is actually inverted */}
            {isDefaultLanguage
              ? t(`translationToggle.translated`)
              : t(`translationToggle.original`)}
          </Typography>
        }
      />
    </FormGroup>
  );
};

export default TranslationToggle;
